import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Text16, Title4 } from '@sorare/core/src/atoms/typography';
import Cards from '@sorare/core/src/atoms/ui/Cards';
import { glossary } from '@sorare/core/src/lib/glossary';

const messages = defineMessages({
  title: {
    id: 'DepositCard.EmptyState.title',
    defaultMessage: 'No Cards found',
  },
  desc: {
    id: 'DepositCard.EmptyState.details',
    defaultMessage:
      'We couldn’t find any Card linked to your Ethereum account ({accountAddress}). Please make sure you have a Card to deposit and try again.',
  },
});

const Container = styled(Vertical).attrs({ gap: 2, center: true })`
  margin: 0 auto;
`;

type Props = {
  closeDialog: () => void;
  accountAddress?: string;
};

const EmptyState = ({ closeDialog, accountAddress }: Props) => {
  return (
    <Container>
      <Cards />
      <Title4>
        <FormattedMessage {...messages.title} />
      </Title4>
      <Text16 className="text-center">
        <FormattedMessage {...messages.desc} values={{ accountAddress }} />
      </Text16>
      <Button fullWidth size="medium" color="quaternary" onClick={closeDialog}>
        <FormattedMessage {...glossary.close} />
      </Button>
    </Container>
  );
};

export default EmptyState;
